/// <reference types="./line.d.mts" />
import * as $svg from "../../ds/internals/svg.mjs";

export function line() {
  return $svg.square(
    12,
    "<line x1=\"-2\" y1=\"6\" x2=\"14\" y2=\"6\" stroke=\"currentColor\"/>",
  );
}
